/**
 * Portal helper
 *
 * Portal helper contains helper functions that are useful throughout the application
 */

// the constructor for this object
function MyPortalHelper() { }

// the object
MyPortalHelper.prototype = {
    constructor: MyPortalHelper,

    debugMessage: function(message)
    {
        if (PortalConfig.debug) {
            // eslint-disable-next-line no-console
            console.log(message);
        }
    },

    // clone a multi-dimensional array, stripping reference
    cloneArray: function(array)
    {
        return JSON.parse(JSON.stringify(array));
    },

    // redirect the user to the home page
    sendToDashboard: function()
    {
        window.location = '/portal/home/index';
    },

    // toggle the loading veil on a specified element
    loadingOverlay: function(element, status)
    {
        if (status == true) {

            // scrolling resets for the table wrappers
            $(element).scrollTop(0);
            $(element).scrollLeft(0);

            $(element).addClass('loading');
        } else {
            $(element).removeClass('loading');

            //some boxes start hidden from view when a page first loads. undo this class
            $(element).removeClass('start-hidden');
        }
    },

    // creates an event that hides the dropdown when a link in it is clicked
    hideDropdownOnClick: function(selector)
    {
        // get the root elment of the dropdown
        if ($(selector).hasClass('selection-popup')) {
            var dropdownElement = $(selector);
        } else {
            var dropdownElement = $(selector).parents('.selection-popup');
        }

        // when a link is clicked, hide the popup for a short moment to remove the show-on-hover
        $('ul a', dropdownElement).on('click', function() {
            $('.popup', dropdownElement).addClass('hide-popup');
            setTimeout(function() {
                $('.popup', dropdownElement).removeClass('hide-popup');
            }, 250);
        });
    },

    /** Returns a list of Customer Account IDs that the current user has admin
     *  access to. Useful to filter out accounts that the user has no access to
     *  modify.
     */
    getAdminAccountIDs: function()
    {
        var adminAccounts = PortalMain.PortalAccounts.getAdminAccounts();
        var adminIDs = [];
        for (var i in adminAccounts) {
            adminIDs.push(adminAccounts[i].account_id);
        }
        return adminIDs;
    },

    // return chart with only the provided columns from the chart data
    chartGetColumns: function(chartData, chartColumns)
    {
        var newChartData = [];
        var keepKeys = [];

        // convert the chart columns to lowercase for loose comparison
        for (var i in chartColumns) {
            chartColumns[i] = chartColumns[i].toLowerCase();
        }

        // find the keys to keep from the header row
        var headerRow = chartData[0];
        for (var i in headerRow) {
            if (chartColumns.indexOf(headerRow[i].toLowerCase()) != -1) {
                keepKeys.push(i);
            }
        }

        // get the new chart data based on the keep keys
        for (var i in chartData) {
            var row = chartData[i];
            var newRow = [];
            for (var iRow in row) {
                if (keepKeys.indexOf(iRow) != -1) {
                    newRow.push(row[iRow]);
                }
            }
            newChartData.push(newRow);
        }

        return newChartData;
    },

    // enforce a strict order for the columns of the chart data
    chartOrderColumns: function(chartData, columnOrder)
    {
        var newChartData = [];
        var orderKeys = [];

        // find the keys for the new column order
        var headerRow = chartData[0];
        for (var i in columnOrder) {
            for (var columnKey in headerRow) {
                if (columnOrder[i] == headerRow[columnKey]) {
                    orderKeys.push(columnKey);
                }
            }
        }

        // move the columns to the new chart data based on the order keys
        for (var i in chartData) {
            var row = chartData[i];
            var newRow = [];
            for (var i2 in orderKeys) {
                var orderKey = orderKeys[i2];
                newRow.push(row[orderKey]);
            }
            newChartData.push(newRow);
        }

        return newChartData;
    },

    // take a number and apply thousand separating commas
    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    numberWithCommas: function(x)
    {
        var parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
    },

    // turn a number into a dollar format with thousand separators
    numberToDollars: function(number, fixed = 2, softFix = false)
    {
        // convert to a float
        number = parseFloat(number);

        // fix to the specified decimal spot
        if (softFix == true && number % 1 != 0) {
            var decimalDigits = number.toString().split(".")[1].length;
            if (decimalDigits > fixed) {
                fixed = decimalDigits;
            }
        }
        number = number.toFixed(fixed);


        // add commas to the thousand separator (only pre decimal)
        var split = number.toString().split('.');
        var dollars = split[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        if (split.length == 2) {
            dollars += '.' + split[1];
        }

        // remove the leading zero if it exists
        if (dollars[0] == '0' && number != 0) {
            dollars = dollars.toString().substr(1);
        }

        // add the currency symbol
        dollars = '$' + dollars;

        return dollars;
    },

    // convert a date object, or string to the format that should be used across the portal
    formatDate: function(date)
    {
        // convert string to a date object
        if(!(date instanceof Date)) {
            var dateArr = date.split(/[^0-9]/);
            date = new Date (dateArr[0], dateArr[1]-1, dateArr[2]);
        }

        var day = date.getDate();
        var month = date.getMonth() + 1;
        var year = date.getFullYear();
        var time = date.toLocaleTimeString();

        var formattedDate = ('0' + month).slice(-2) + '.' + ('0' + day).slice(-2) + '.' + year;

        return formattedDate;
    },

    // convert a date object, or string to a time string that should be used across the portal
    formatTime: function(date)
    {
        // convert string to a date object
        if(!(date instanceof Date)) {
            var dateArr = date.split(/[^0-9]/);
            date = new Date (dateArr[0], dateArr[1]-1, dateArr[2], dateArr[3], dateArr[4], dateArr[5] );
        }

        var meridiem = Math.floor(date.getHours() / 12) == 0 ? 'AM' : 'PM';
        var hour = date.getHours() % 12 == 0 ? 12 : date.getHours() % 12;
        var minute = date.getMinutes();

        var formattedTime = hour + ':' + ('0' + minute).slice(-2) + '&nbsp;' + meridiem;

        return formattedTime;
    },

    // converts bytes (or hertz) to larger, easier-to-interpret units
    // returns an array containing a rounded number, and the unit of measure
    formatBytes: function(value, minUnit, maxUnit, unitType, newPower)
    {
        // the base sizes available, and the power
        if (unitType == 'hertz') {
            var sizes = ['Hz', 'KHz', 'MHz', 'GHz', 'THz', 'PHz', 'EHz'];
            var power = 1000;
        } else if (unitType == 'bits'){
            var sizes = ['b', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb'];
            var power = 1000;
        } else {
            var sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
            var power = 1000;
        }

        if (newPower != undefined) {
            var power = newPower;
        }

        // determine the maximum unit and get the max key of the sizes array
        var maxSizeKey = 99999;
        if (maxUnit != undefined && maxUnit != false  && maxUnit != null) {
            for(var i in sizes) {
                if (sizes[i].toLowerCase() == maxUnit.toLowerCase()) {
                    maxSizeKey = i;
                    break;
                }
            }
        }

        // determine the minimum unit and get the min key of the sizes array
        var minSizeKey = 0;
        if (minUnit != undefined && minUnit != false  && minUnit != null) {
            for(var i in sizes) {
                if (sizes[i].toLowerCase() == minUnit.toLowerCase()) {
                    minSizeKey = i;
                    break;
                }
            }
        }

        // determine if it's a negative value, and get the absolute value
        var negative = value < 0 ? true : false;
        value = Math.abs(value);

        // if zero, save some trouble and return as such
        if (value == 0) {
            return [0, sizes[minSizeKey]];
        }

        // break down into the proper unit of measurement using the min and max size key
        var sizeKey = parseInt(Math.floor(Math.log(value) / Math.log(power)));
        sizeKey = sizeKey > maxSizeKey ? maxSizeKey : sizeKey;
        sizeKey = sizeKey < minSizeKey ? minSizeKey : sizeKey;

        // format the total to show 3 digits minimum
        var total = value / Math.pow(power, sizeKey);
        var wholeNumber = parseInt(total).toString();
        var remainingDigits = 3 - wholeNumber.length;
        if (remainingDigits < 0) {
            var finalNumber = Math.round(total);
        } else {
            var factor = Math.pow(10, remainingDigits);
            var finalNumber = Math.round(total * factor) / factor;
        }

        // apply the negative
        finalNumber = negative === true ? finalNumber * -1 : finalNumber;

        return [finalNumber, sizes[sizeKey]];
    },

    // disable a button
    disableButton: function(selector)
    {
        $(selector).attr('disabled','disabled');
    },

    // enable a button
    enableButton: function(selector)
    {
        $(selector).prop('disabled', false);
        $(selector).removeAttr('disabled');
    },

    // get a parameter from the url
    // https://davidwalsh.name/query-string-javascript (fallback for maximum browser support)
    getUrlParameter: function (name)
    {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },

    // get all URL parameters
    getAllUrlParameters() {
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = decodeURI(value);
        });
        return vars;
    },

    // setup the error popup
    openErrorPopup: function(headline, content, options = {})
    {
        $('.error-popup h3').html(headline);
        $('.error-popup p.content').html(content);

        $('.error-popup a.close').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.error-popup').addClass('hidden');
            $('.error-popup a.close').off('click');
        });

        $('.error-shade').on('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            $('.error-popup').addClass('hidden');
            $('.error-shade').off('click');
        });

        if (typeof options.loading != 'undefined') {
            $('.error-popup p.content').append('<div class="loading"></div>');
        }

        $('.error-popup').removeClass('hidden');
    },

    // convert line breaks to br tags
    breaksToBr: function(string)
    {
        if (string !== null) {
            return string.replace(/(?:\r\n|\r|\n)/g, '<br />');
        }

        return '';
    },

    // decode an htmlspecialchars string
    htmlspecialcharsDecode: function(str) {
        if (typeof(str) == "string") {
            str = str.replace(/&gt;/ig, ">");
            str = str.replace(/&lt;/ig, "<");
            str = str.replace(/&#039;/g, "'");
            str = str.replace(/&quot;/ig, '"');
            str = str.replace(/&amp;/ig, '&'); /* must do &amp; last */
        }
        return str;
    },

    // download binary data as a file
    downloadFile: function(data, fileName) {
        var blob = new Blob([data]);

        if (window.navigator.msSaveOrOpenBlob) {
            // ie/edge
            window.navigator.msSaveBlob(blob, fileName);

        } else {
            // other browsers
            var link = document.createElement('a');
            var url = window.URL.createObjectURL(blob);
            link.href = url;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            setTimeout(function() {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }, 50);
        }
    },

}

// This jump starts the Portal
var PortalHelper = new MyPortalHelper;
